import { PopoverArrow } from './PopoverArrow';

// TODO: in v9, move styled() from PopoverArrow.jsx to here
export var StyledPopoverArrow = PopoverArrow;